import Vue from 'vue'

const eventBus = new Vue()

export default eventBus

export const eventType = {
  ViewImages: 'ViewImages',
}



// WEBPACK FOOTER //
// ./src/utils/eventBus.js